import React from 'react';
import { secondary_color_50 } from '../../styles/_variables';

import styles from './HeaderPage.module.scss'

interface Props {
  header:string;
  bageColor: string;
  children?: React.ReactNode;
}

const HeaderPage = ({header, bageColor=secondary_color_50}:Props) => {
  return (
    <header className={styles.header}>
      <div className={styles.badge} style={{background: bageColor}}/>
      <div>{header}</div>
    </header>
  )
}

export default HeaderPage;